import React, { ReactNode } from "react";
import { Link, LinkProps, useNavigate } from "react-router-dom";
import { useNavigationBlocker } from "@/contexts/NavigationBlockerContext";
import { debugLog, debugError } from "@/lib/debug";

interface SafeLinkProps extends Omit<LinkProps, "onClick"> {
  children: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const SafeLink = ({ children, to, onClick, ...props }: SafeLinkProps) => {
  const { checkNavigation } = useNavigationBlocker();
  const navigate = useNavigate();

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    debugLog("SafeLink", "Клик по ссылке:", to);
    console.log("[SafeLink] Клик по ссылке:", to);

    if (onClick) {
      onClick(e);
    }

    try {
      console.log("[SafeLink] Проверяем навигацию для:", to);
      const canNavigate = await checkNavigation();
      debugLog("SafeLink", "Можем навигировать:", canNavigate, "к:", to);
      console.log("[SafeLink] Результат проверки навигации:", canNavigate, "для:", to);

      if (canNavigate) {
        // Переходим через React Router
        console.log("[SafeLink] Выполняем навигацию к:", to);
        navigate(to);
      } else {
        console.log("[SafeLink] Навигация заблокирована для:", to);
      }
    } catch (error) {
      debugError("SafeLink", "Ошибка при проверке навигации:", error);
      console.error("[SafeLink] Ошибка при проверке навигации:", error);
      // В случае ошибки все равно пытаемся перейти
      navigate(to);
    }
  };

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
};
